import React, {useState, useCallback} from 'react';
import './DynamicListHeader.scss'
import Info from "../Info/Info";
import {Translation} from "react-i18next";
import {FaSortUp, FaSortDown} from 'react-icons/fa'

const settingsGear = '/imgs/app/settings-gear.png';

const DynamicListHeader = ({width, customMenuView, addButtonClicked, titleObjectsArray, onSelectedColumnChanged, menuWidth = 0,
                             showBorder = false, className = '', canSortList = false, clampFirstColumn = false,
                             initialSelectedColumn = 0, selectedColumn: controlledSelectedColumn,
                             ascending: controlledAscending, borderWidth = 0.5, semanticMode = false,
                             menuAriaLabel, showSortIndicators = true}) => {
  
  // Instance Variables
  
  const [internalAscending, setInternalAscending] = useState(false);
  const [internalSelectedColumn, setInternalSelectedColumn] = useState(initialSelectedColumn);
  const ascending = controlledAscending === undefined ? internalAscending : controlledAscending;
  const selectedColumn = controlledSelectedColumn === undefined ? internalSelectedColumn : controlledSelectedColumn;
  
  // Methods
  
  const handleSelectedColumnChanged = useCallback((aColumn) => {
    const nextAscending = aColumn === selectedColumn ? !ascending : false;

    if(aColumn !== selectedColumn){
      if(controlledAscending === undefined){
        setInternalAscending(false);
      }
      if(controlledSelectedColumn === undefined){
        setInternalSelectedColumn(aColumn);
      }
    }
    else{
      if(controlledAscending === undefined){
        setInternalAscending(nextAscending);
      }
    }
    if(onSelectedColumnChanged){
      onSelectedColumnChanged(aColumn, nextAscending);
    }
  }, [ascending, controlledAscending, controlledSelectedColumn, selectedColumn, onSelectedColumnChanged]);
  
  const flexForWidth = (aColumnWidth) => {
    return '0 0 ' + aColumnWidth.toString() + 'px';
  };

  const titleForObject = (titleObject) => (
    titleObject.customTitle ?
      titleObject.customTitle
      :
      <Translation>{ (t, { i18n }) => t(titleObject.key) }</Translation>
  );
  
  // Render
  
  return (
    <div className={'dynamic-list-header-container ' + className}
         role={semanticMode ? 'row' : undefined}
         style={{width:width + 'px'}}>
      {titleObjectsArray.map((titleObject, index) => {
        const sortable = !titleObject.customView &&
          (titleObject.sortable === undefined ? canSortList : titleObject.sortable);
        const ariaSort = semanticMode && sortable ?
          (selectedColumn === index ? (ascending ? 'ascending' : 'descending') : 'none')
          :
          undefined;

        return (
          <div className={'dynamic-list-header-title-cell ' + ((index === selectedColumn) ? 'dynamic-list-header-title-cell-selected ' : '')  + (clampFirstColumn ? 'dynamic-list-header-clamped ' : '') + (showBorder ? 'dynamic-list-header-border ' : '')}
               style={{padding:titleObject.customView ? 0 : '10px', paddingLeft:titleObject.customView ? 0 : (index === 0 ? '20px' : '10px'), width:titleObject.width, flex:flexForWidth(titleObject.width), borderWidth:showBorder ? borderWidth : 1.0, borderTopWidth:showBorder ? borderWidth : 0, borderLeftWidth:index === 0 ? borderWidth : 0, borderRightWidth:showBorder ? (clampFirstColumn && index === 0 ? 2 * borderWidth : borderWidth) : 0}}
               key={titleObject.key + '-' + index}
               role={semanticMode ? 'columnheader' : undefined}
               aria-sort={ariaSort}
               onClick={(aEvent) => {
                 // Preserve programmatic clicks on the historical header cell
                 // while normal pointer and keyboard interaction uses a button.
                 if(sortable && aEvent.target === aEvent.currentTarget){
                   handleSelectedColumnChanged(index);
                 }
               }}>
            {titleObject.customView ?
              <div className="dynamic-list-header-custom-view-container">
                {titleObject.customView}
              </div>
              :
              <span className="dynamic-list-header-title">
                {sortable ?
                  <button className="dynamic-list-header-sort-button"
                          type="button"
                          aria-label={titleObject.ariaLabel}
                          onClick={(aEvent) => {
                            aEvent.preventDefault();
                            aEvent.stopPropagation();
                            handleSelectedColumnChanged(index);
                          }}>
                    <span>{titleForObject(titleObject)}</span>
                    {showSortIndicators ?
                      (ascending && selectedColumn === index ?
                        <FaSortUp aria-hidden="true"
                                  className="dynamic-list-header-arrow-up"/>
                        :
                        <FaSortDown aria-hidden="true"
                                    className="dynamic-list-header-arrow-down"/>
                      )
                      :
                      null
                    }
                  </button>
                  :
                  <span>{titleForObject(titleObject)}</span>
                }

                {titleObject.description ?
                  <Info className="dynamic-list-header-info"
                        message={titleObject.description}
                  />
                  :
                  null
                }
              </span>
            }
          </div>
        )
      })}
      
      {menuWidth > 0 ?
        customMenuView ?
          customMenuView
          :
          addButtonClicked ?
            <div className={showBorder ? 'dynamic-list-header-menu-border' : 'dynamic-list-header-menu-space'}
                 role={semanticMode ? 'columnheader' : undefined}
                 style={{width:menuWidth + 'px', borderWidth:showBorder ? borderWidth : 1.0, borderTopWidth:borderWidth, borderLeftWidth:0, borderRightWidth:borderWidth}}>
              <Translation>
                {(t, {i18n}) =>
                  <button className="dynamic-list-header-settings-button"
                          type="button"
                          aria-label={menuAriaLabel || t('SETTINGS')}
                          onClick={(aEvent) => {
                            aEvent.preventDefault();
                            aEvent.stopPropagation();
                            addButtonClicked(aEvent);
                          }}>
                    <img src={settingsGear}
                         alt=""
                         aria-hidden="true"
                         style={{width:'20px', height:'20px'}}
                    />
                  </button>
                }
              </Translation>
            </div>
            :
            <div className={showBorder ? 'dynamic-list-header-menu-border' : 'dynamic-list-header-menu-space'}
                 role={semanticMode ? 'columnheader' : undefined}
                 aria-label={semanticMode ? menuAriaLabel : undefined}
                 style={{width:menuWidth + 'px', borderWidth:showBorder ? borderWidth : 1.0}}
            />
        :
        null
      }
    </div>
  )
};

export default DynamicListHeader
